import { RequirementType } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import {
  RequirementTableCallback,
  RequirementTableItemData,
  RequirementTableRowConfig
} from "../../types";
import { buildConfigFields } from "../../utils";

import { usePayeePayoutMethodConfig } from "./configs/payee/usePayeePayoutMethodConfig";
import { usePayerPayoutMethodConfig } from "./configs/payer/usePayerPayoutMethodConfig";

export const usePayoutMethodRequirementTableConfig = (
  callback: RequirementTableCallback,
  requirements: RequirementTableItemData[]
): RequirementTableRowConfig[RequirementType.PAYOUT_METHOD] => {
  const payerPayoutMethodConfig = usePayerPayoutMethodConfig(callback);
  const payeePayoutMethodConfig = usePayeePayoutMethodConfig(callback);

  const fields = useMemo(
    () =>
      buildConfigFields<undefined, RequirementType.PAYOUT_METHOD>({
        payerConfig: payerPayoutMethodConfig,
        payeeConfig: payeePayoutMethodConfig,
        getAdditionalData: () => undefined,
        // Payout-method status lives on the requirement itself, not on a document.
        hasDataSource: false
      })(),

    [payerPayoutMethodConfig, payeePayoutMethodConfig]
  );

  return {
    ...fields,
    getAdditionalData: () => undefined,
    isLoading: false,
    isFetching: false,
    dataUpdatedAt: ""
  };
};
